import React from "react";

export const GreyedBubblesIllustration = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="155"
    height="123"
    viewBox="0 0 155 123"
    fill="none"
  >
    <path
      fill="#F2F6F8"
      fillRule="evenodd"
      d="M131.5 27.7c9.5 14.4 6 33.7-.2 49.8-5.9 14.8-18.4 25-32.3 32.7-14.3 8-30.5 15.7-46 10.4-15.2-5.2-23.6-21-29.2-36.2-4.8-13-2-26.5 1-40C28.3 29 28.5 10 42.2 2.4 56.1-5 71.8 6.4 87 10.7c16 4.4 35.4 3.2 44.6 17Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3DEE6"
      d="M121.4 48a24 24 0 0 0-1-5.5c-3-9.4-11.7-15.4-23.5-18.8-9-2.6-19.8-3.7-31.2-3.7C36.8 20 .9 35.8.9 50.7c0 9.7 6.6 17 16.8 22.1L8.5 87.1c-2.6 4.1 1.7 5.6 4.9 3.6L32.2 78c11.9 3 25.8 3.8 39 2.7C74 72.5 81 67 90.2 63.6a72 72 0 0 1 14.6-3.6c4.4-.6 9.1-.6 13.9 0a20 20 0 0 0 2.7-12Z"
    />
    <path
      fill="#D3DEE6"
      d="m73 80.5-1.8.2A25.9 25.9 0 0 0 70 92.5c2.8 22 31.4 27.9 54.5 21.7l3.6-1.3 15.2 7.2c1.7.8 2.2-.3 1.7-1.5l-4.4-11.4c9-6 14.7-14.6 13.1-25.4C152.3 71 135.5 62 118.7 60c-7 11.6-25.4 18.5-45.7 20.5Z"
    />
    <path
      fill="#AFC5D4"
      d="M104.8 60a72 72 0 0 0-14.6 3.6c-9.2 3.4-16.2 8.9-19 17H73c20.3-2 38.8-9 45.7-20.6-4.8-.6-9.5-.6-13.9 0Z"
    />
    <path
      fill="#698CA5"
      fillRule="evenodd"
      d="m123 98.3-.2-.4-.6-.8-.9-1-.7-.8a471.7 471.7 0 0 0-5.6-6.6l.3-.4.4-.6 3.7-4 3.6-4c.2-.3-.3-.6-.9-1-.3 0-.7-.2-1-.4l-.7-.3-.3-.1c-.5-.2-.6-.2-.9.2l-.7 1-.6.8-4.5 5.1-.8 1-.9-1c-1.8-2-3.7-4-4.5-5.1l-.6-.9-.6-.9c-.3-.4-.5-.4-1-.2l-.2.1-.7.3-1 .5c-.6.3-1.1.6-1 .8l3.7 4a102 102 0 0 1 3.7 4l.4.7.3.4-4.1 4.9-1.6 1.7-.7.8-.8 1-.6.8-.2.3.2.2 2.1 1.5c.4.3.5.3.8 0l.7-.6 1.4-1.5a161.2 161.2 0 0 0 5.2-5.8l1.5 1.8 3.7 4 1.4 1.5.7.6c.3.3.4.3.8 0l2-1.5.2-.1Z"
      clipRule="evenodd"
    />
    <path
      fill="#8FACC1"
      d="M79.3 43.6c1-.9 2.8-1.3 4.2-1.1v-.2l-.5-4.4-.4-3.3c0-.3-.2-.4-.5-.4h-1.6L75 35l-5.9 1L62 37l-8.5 1.3L43 40l-5.1.7c-.7 0-1.3.2-1.9.3-.3 0-.5.2-.4.6l.1.4c.3 1 1 5.5 1.1 6.6L37 50c2-.6 3.2-.2 4.9 1 .9.6 1.2 1.6 1 2.7-.1 1-.7 1.8-1.7 2.1-.3.2-.7.2-1 .3l-2.6.8.2 2.8.7 5.4c.1 1 .1 1 1.2.9l7.6-1.3 3.4-.7c1.7-.5 21.3-3.7 22.6-3.8l7-.7L84 59l.7-.1c.7-.1.5-1.5.5-1.7l-.3-1.5a321.2 321.2 0 0 1-.8-6.7 10 10 0 0 1-3.9.6c-1.8-.1-2.8-4.2-1-6Zm-34-2.1.5-.1.4 3h-.6l-.3-3Zm.6 4.8h.6l.3 2.9h-.6l-.3-2.9Zm.6 5 .6-.2.3 3H47l-.4-2.9ZM47 56h.6l.4 2.8-.6.1-.4-3Zm1 7.8-.4-3h.6l.4 2.9H48Z"
    />
  </svg>
);
